import type { Menu } from '#/global'

const menus: Menu.recordRaw = {
  path: '/permission_example',
  meta: {
    title: '权限验证',
    icon: 'ri:shield-keyhole-line',
  },
}

export default menus
